'use client';

import { useEffect, useRef } from 'react';

/**
 * Hook to run a callback only once per page hit.
 */
const useRunOnce = (callback: () => void) => {
    const hasRun = useRef(false);

    useEffect(() => {
        if (hasRun.current) {
            return;
        }

        if (typeof callback === 'function') {
            callback();
        }
        hasRun.current = true;
    }, []); // eslint-disable-line
};

export default useRunOnce;
